import {apolloClient, gql} from '../graphql';
import {normalizeGraphQLObject} from '../graphql/helpers';
import {type Tag} from 'shared/src/models';
import {type TagColor} from 'shared/src/tags';

export const getTags = async (): Promise<Tag[]> => {
	const {data, error} = await apolloClient.query({
		query: gql(/* GraphQL */ `
			query GetTags {
				tags {
					id
					name
					color
					internalId
					parentTagId
				}
			}
		`),
		fetchPolicy: 'no-cache',
	});

	if (error) {
		throw error;
	}

	return data.tags.map((tag) => ({
		...normalizeGraphQLObject(tag),
		color: tag.color as TagColor,
	}));
};

export const getTagByInternalId = async (internalId: string): Promise<Tag> => {
	const tags = await getTags();

	const tag = tags.find((tag) => tag.internalId === internalId);

	if (tag) {
		return tag;
	} else {
		throw new Error(`Tag with internal ID ${internalId} not found`);
	}
};
